import axios from 'axios'
import { PARAM_CSRF_TOKEN } from '../../constants'
import { requestInterceptor, responseInterceptor, errorHandler } from './interceptors'
import config from '../../config'

const axiosConfig = axios.create({
  withCredentials: true,
  // this is the header name that backend will inspect
  xsrfCookieName: PARAM_CSRF_TOKEN,
  xsrfHeaderName: PARAM_CSRF_TOKEN,
  baseURL: config.backendUrl
})

axiosConfig.interceptors.request.use(requestInterceptor, errorHandler)
axiosConfig.interceptors.response.use(responseInterceptor, errorHandler)

export default axiosConfig

// ReExporting for legacy Tests
export { injectHeaders as addHeaders, errorHandler as handleError } from './interceptors'
